export var EntityMetricRecorderPrincipalType;
(function (EntityMetricRecorderPrincipalType) {
    EntityMetricRecorderPrincipalType["UNKNOWN"] = "GhUnknown";
    EntityMetricRecorderPrincipalType["GhBot"] = "GhBot";
    EntityMetricRecorderPrincipalType["GhUser"] = "GhUser";
    EntityMetricRecorderPrincipalType["GhTeam"] = "GhTeam";
    EntityMetricRecorderPrincipalType["GhRepo"] = "GhRepo";
    EntityMetricRecorderPrincipalType["GhOrg"] = "GhOrg";
})(EntityMetricRecorderPrincipalType || (EntityMetricRecorderPrincipalType = {}));
export var EntityMetricRecorderMetricName;
(function (EntityMetricRecorderMetricName) {
    EntityMetricRecorderMetricName["PrCreate"] = "EMRMN_PrCreate";
    EntityMetricRecorderMetricName["PrMerge"] = "EMRMN_PrMerge";
    EntityMetricRecorderMetricName["PrEnrich"] = "EMRMN_PrEnrich";
    EntityMetricRecorderMetricName["PrReview"] = "EMRMN_PrReview";
    EntityMetricRecorderMetricName["PrReviewComment"] = "EMRMN_PrRC";
    EntityMetricRecorderMetricName["PrReviewCommentResolve"] = "EMRMN_PrRCR";
    EntityMetricRecorderMetricName["PrCancelled"] = "EMRMN_PrCancelled";
    EntityMetricRecorderMetricName["CommitPush"] = "EMRMN_CommitPushWithSize";
    EntityMetricRecorderMetricName["IssueCreate"] = "EMRMN_IssueCreate";
    EntityMetricRecorderMetricName["IssueMerge"] = "EMRMN_IssueMerge";
    EntityMetricRecorderMetricName["IssueEnrich"] = "EMRMN_IssueEnrich";
    EntityMetricRecorderMetricName["IssueReview"] = "EMRMN_IssueReview";
    EntityMetricRecorderMetricName["IssueCancelled"] = "EMRMN_IssueCancelled";
    EntityMetricRecorderMetricName["PrNumCommitByPr"] = "EMRMN_ByPr_PrNumCommit";
    EntityMetricRecorderMetricName["PrLifetimeByOrg"] = "EMRMN_ByPr_PrLifetime";
    EntityMetricRecorderMetricName["PrLifetimeByRepo"] = "EMRMN_ByRepo_PrLifetime";
    EntityMetricRecorderMetricName["ActionsByRepo"] = "EMRMN_ByRepo_Actions";
    EntityMetricRecorderMetricName["ReleasesByRepo"] = "EMRMN_ByRepo_Releases";
    EntityMetricRecorderMetricName["PrOpenLongerThan7Days"] = "EMRMN_ByPr_PrOpenLongerThan7Days";
    EntityMetricRecorderMetricName["PrOpenLongerThan30Days"] = "EMRMN_ByPr_PrOpenLongerThan30Days";
    EntityMetricRecorderMetricName["BranchesNumActiveByMonth"] = "EMRMN_ByOrg_BranchesNumActive";
})(EntityMetricRecorderMetricName || (EntityMetricRecorderMetricName = {}));
;
export var EntityMetricRecorderFrequency;
(function (EntityMetricRecorderFrequency) {
    EntityMetricRecorderFrequency["Daily"] = "EMRRF.Daily";
    EntityMetricRecorderFrequency["Weekly"] = "EMRRF.Weekly";
    EntityMetricRecorderFrequency["Monthly"] = "EPRRF.Monthly";
})(EntityMetricRecorderFrequency || (EntityMetricRecorderFrequency = {}));
;
export var EntityMetricRecorderOperator;
(function (EntityMetricRecorderOperator) {
    EntityMetricRecorderOperator["INC"] = "EMRO.Inc";
    EntityMetricRecorderOperator["AVG"] = "EMRO.Avg";
})(EntityMetricRecorderOperator || (EntityMetricRecorderOperator = {}));
;
;
export var EventTargetObjectType;
(function (EventTargetObjectType) {
    EventTargetObjectType["UNKNOWN"] = "eto_unknown";
    EventTargetObjectType["BRANCH"] = "eto_branch";
    EventTargetObjectType["COMMIT"] = "eto_commit";
    EventTargetObjectType["PR"] = "eto_pr";
    EventTargetObjectType["ISSUE"] = "eto_issue";
})(EventTargetObjectType || (EventTargetObjectType = {}));
export var EventActionCode;
(function (EventActionCode) {
    EventActionCode["UNKNOWN"] = "eac.unknown";
    EventActionCode["BRANCHOPEN"] = "eac.branchopen";
    EventActionCode["BRANCHDELETE"] = "eac.branchdelete";
    EventActionCode["PUSH"] = "eac.push";
    EventActionCode["MERGESRC"] = "eac.mergesrc";
    EventActionCode["MERGEDST"] = "eac.mergedst";
    EventActionCode["PROPEN"] = "eac.propen";
    EventActionCode["PRSYNC"] = "eac.prsync";
    EventActionCode["PRSETDRAFT"] = "eac.prsetdraft";
    EventActionCode["PRSETREADYForReview"] = "eac.prsetreadyforreview";
    EventActionCode["PRASSIGNED"] = "eac.prassigned";
    EventActionCode["PRLABELED"] = "eac.prlabeled";
    EventActionCode["PRUNLABELED"] = "eac.prunlabeled";
    EventActionCode["PRREOPEN"] = "eac.prreopen";
    EventActionCode["PRMILESTONE"] = "eac.prmilestone";
    EventActionCode["PRDEMILESTONE"] = "eac.prdemilestone";
    EventActionCode["PRDEQUEUED"] = "eac.prdequeued";
    EventActionCode["PRREQUESTREVIEW"] = "eac.prrequestreview";
    EventActionCode["REVIEW"] = "eac.review";
    EventActionCode["CLOSEUNKNOWN"] = "eac.closeunknown";
    EventActionCode["CLOSEMERGE"] = "eac.closemerge";
    EventActionCode["CLOSECANCEL"] = "eac.closecancel";
})(EventActionCode || (EventActionCode = {}));
;
;
;
